import { withStyles, Checkbox } from "@material-ui/core";
import React, { memo } from "react";
import { WarningOutlined as WarningOutlinedIcon } from "@material-ui/icons";
import { getWarningLabel } from "../utils";

const styles = (theme) => ({
  container: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row",
    background: theme.warningBGColor,
    padding: "13 13 0 13",
  },
  label: {
    color: theme.warningTextColorDispatch,
    fontWeight: 500,
    fontSize: theme.headerTextFontSize,
  },
  description: {
    color: theme.warningTextColorDispatch,
    fontWeight: 400,
    fontSize: theme.headerTextFontSize,
  },
  warningIcon: {
    color: theme.warningTextColorDispatch,
    marginRight: 9,
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
  },
  checkboxLabel: {
    fontSize: theme.headerTextFontSize,
    lineHeight: "19px",
    color: theme.iconColor,
    fontWeight: 500,
  },
  root: {
    paddingLeft: 0,
    paddingRight: 10,
    display: "flex",
    verticalAlign: "middle",
    height: "100%",
    color: theme.gridIconBorderColor,
    "&$checked": {
      color: theme.HeaderSelectedText,
    },
  },
  checked: {},
});

const Warning = ({
  mode,
  warning: { label, description },
  hasWarning,
  classes,
  onToggleWarningOverride,
  overrideWarning,
}) => (
  <>
    {hasWarning && (
      <div className={classes.container}>
        <WarningOutlinedIcon className={classes.warningIcon} />
        <div>
          <div className={classes.label}>{label}</div>
          <div className={classes.description}>{description}</div>
          <div className={classes.checkboxContainer}>
            <Checkbox
              classes={{
                root: classes.root,
                checked: classes.checked,
              }}
              disableRipple
              color="primary"
              onChange={onToggleWarningOverride}
              checked={overrideWarning}
            />
            <span className={classes.checkboxLabel}>
              {getWarningLabel(mode)}
            </span>
          </div>
        </div>
      </div>
    )}
  </>
);

export default withStyles(styles)(memo(Warning));
